var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"c-btn",class:{ 'c-btn--large' : _vm.large },attrs:{"to":_vm.to}},[_c('span',{staticClass:"c-btn__label"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }